import { spacing, borderRadius } from "@magicbi/ui-library";

/** Nav row height: design 34px = spacing 8 (32) + spacing 0.5 (2). Not a spacing step, so it is a component size. */
export const NAV_ROW_HEIGHT = `calc(${spacing[8]} + ${spacing[0.5]})`;
/** Nav row corner radius: design 10px (T0 exact-px radius; UL has only 8 and 12). */
export const NAV_ROW_RADIUS = borderRadius[10];
/** Icon size and stroke of every nav row (design: 18px, stroke 1.75). */
export const NAV_ICON_SIZE = 18;
export const NAV_ICON_STROKE = 1.75;

/** Drawer width: design 288px; nearest token (spacing 72 = 18rem). */
export const NAV_DRAWER_WIDTH = "18rem";
/** Pin / unpin resize and hover-preview slide, from the approved mock. No 200/300ms duration token exists yet. */
export const NAV_PIN_MS = 300;
export const NAV_PEEK_MS = 200;
